module.exports = __webpack_public_path__ + "img/fechar-icon.55455cd9.svg";